import {Inject, Injectable} from '@angular/core';
import {PlaceholderCategory} from '@domain/textile-data/finishing-and-finishing-template/placeholder-category';
import {ProductConfigurations, PRODUCT_CONFIGURATIONS} from '@infrastructure/http/product-configuration/product-configuration.interface';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class ProductConfigurationPlaceholderService {
  public constructor(@Inject(PRODUCT_CONFIGURATIONS) private readonly productConfigurations: ProductConfigurations) {}

  public getPlaceholderCategories(): Observable<PlaceholderCategory[]>[] {
    const requests: Observable<PlaceholderCategory[]>[] = [];

    requests.push(this.productConfigurations.getCategoriesWithComponentsForProductConfigurationName());

    return requests;
  }
}
